
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInProgress1 as ObiInProgress1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-in-progress-1.js';
 
 
 

 
 export const ObiInProgress1 = createComponent({
   react: React,
   tagName: 'obi-in-progress-1',
   elementClass: ObiInProgress1Element,
   events: {
     
   }
  });
 
 